import Slider from "react-slick/lib/slider";
import Footer from "../../Components/Footer";
import Navbar2 from "../../Components/Navbar2";

import {
  FaClock,
  FaCompass,
  FaPhone,
  FaRegCalendarAlt,
  FaSun,
} from "react-icons/fa";
import { MdRocketLaunch, MdWbTwilight } from "react-icons/md";
import { useEffect, useState } from "react";
import { DetailsFormJSon } from "../LandingPage/LandingPageModel";
import { Test_Book } from "../../Action/ContactAction";
import { TEST_BOOKING_RESET } from "../../Constant/ContactConstant";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import Loading from "../../Components/Loading";

const Faq = [
  {
    title: "What facilities are available at your Delhi center?",
    desc: "Our center features modern classrooms, computer labs with PTE software, air-conditioned rooms, free Wi-Fi, parking facility, and a student lounge area for comfortable learning.",
  },
  {
    title: "Do you provide study materials for PTE preparation?",
    desc: "Yes, we provide comprehensive study materials including practice books, online resources, mock test access, and exclusive tips and strategies developed by our expert trainers.",
  },
  {
    title: "What is the average score improvement with your coaching?",
    desc: "On average, our students see a 20-30 point improvement in their PTE scores. Many achieve their target scores on the first attempt with our proven methodology.",
  },
  {
    title: "Do you offer weekend and evening batches?",
    desc: "Absolutely! We offer morning (7-9 AM), evening (6-8 PM), and weekend (10 AM-4 PM) batches to accommodate different schedules of working professionals and students.",
  },
];

export default function DelhiPte() {
  const [FaqActive, setFaqActive] = useState(null);
  const [StudentForm, setStudentForm] = useState(DetailsFormJSon);
  const dispatch = useDispatch();
  const why_choose = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 600,
    // afterChange: (current) => setCurrentSlide(current),
    slidesToShow: window.innerWidth <= 480 ? 1 : 3,
    slidesToScroll: 1,
  };
  const { loading, success, error } = useSelector((s) => s.Test_Book_Reducer);
  const handleChange = (e) => {
    setStudentForm({ ...StudentForm, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      Test_Book({
        ...StudentForm,
        Location: "Delhi",
        Enquiry_For: "PTE",
        url: window.location.href,
      })
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (success) {
      setStudentForm({ ...DetailsFormJSon });
      setTimeout(() => {
        dispatch({ type: TEST_BOOKING_RESET });
      }, 6000);
    }
  }, [success, dispatch]);

  return (
    <>
      <Helmet>
        {/* Title */}
        <title>
          Best IELTS & PTE Coaching in Delhi | Testifyi – 8+ Band & 79+ Scores
        </title>

        {/* Meta Title */}
        <meta
          name="title"
          content="Best IELTS & PTE Coaching in Delhi | Testifyi – 8+ Band & 79+ Scores"
        />

        {/* Meta Description */}
        <meta
          name="description"
          content="Join Testifyi – Delhi’s leading IELTS & PTE coaching institute. Expert trainers, flexible batches, and proven results: 8+ Band in IELTS & 79+ in PTE."
        />

        {/* Keywords */}
        <meta
          name="keywords"
          content="Best IELTS Coaching in Delhi, Best PTE Coaching in Delhi, IELTS Reality Test, PTE Reality Test, Book Reality Test for IELTS & PTE, Testifyi Reality Test, IELTS Coaching, PTE Coaching, Delhi IELTS, Delhi PTE"
        />

        {/* SEO Essentials */}
        <meta name="robots" content="index, follow" />
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="1 days" />
        <meta name="author" content="Testifyi" />

        {/* Open Graph (Facebook/LinkedIn SEO) */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Best IELTS & PTE Coaching in Delhi | Testifyi – 8+ Band & 79+ Scores"
        />
        <meta
          property="og:description"
          content="Testifyi is Delhi’s trusted IELTS & PTE coaching centre with proven 8+ Band and 79+ results."
        />
        <meta
          property="og:image"
          content="https://yourwebsite.com/seo-banner.jpg"
        />
        <meta property="og:url" content="https://yourwebsite.com/" />

        {/* Twitter Card (Extra for SEO) */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Best IELTS & PTE Coaching in Delhi | Testifyi"
        />
        <meta
          name="twitter:description"
          content="Expert IELTS & PTE coaching with guaranteed results. 8+ Band & 79+ scores."
        />
        <meta
          name="twitter:image"
          content="https://www.testifyi.com/assets/image/ielts-pte-banner.png"
        />
      </Helmet>
      <div className="Delhi_Pte_New ">
        {loading ? <Loading /> : ""}
        <Navbar2 />
        {/* <!-- Hero Section --> */}
        <section class="hero">
          <div class="hero-background">
            <div class="container">
              <div class="hero-content">
                <div class="hero-text">
                  <h1>
                    Master PTE Academic with Delhi's Leading Coaching Center
                  </h1>
                  <p>
                    Achieve your dream PTE score with expert guidance,
                    personalized training, and proven strategies. Join 5000+
                    successful students at Testifyi.
                  </p>

                  <div class="stats">
                    <div class="stat">
                      <h3>98%</h3>
                      <p>Success Rate</p>
                    </div>
                    <div class="stat">
                      <h3>5000+</h3>
                      <p>Students Trained</p>
                    </div>
                    <div class="stat">
                      <h3>79+</h3>
                      <p>Average Score</p>
                    </div>
                  </div>

                  <div class="hero-buttons">
                    <button class="btn-primary">Start Free Demo</button>
                    <button class="btn-secondary">View Courses</button>
                  </div>
                </div>

                <div class="hero-form">
                  <div class="form-container">
                    <h3>Book Your Free Demo</h3>
                    <form onSubmit={handleSubmit}>
                      <input
                        type="text"
                        placeholder="Full Name"
                        name="name"
                        value={StudentForm?.name}
                        onChange={handleChange}
                        required
                      />
                      <input
                        type="email"
                        name="email"
                        value={StudentForm.email}
                        onChange={handleChange}
                        placeholder="Email Address"
                        required
                      />
                      <input
                        type="number"
                        name="phone"
                        value={StudentForm.phone}
                        onChange={handleChange}
                        placeholder="Phone Number"
                        required
                      />
                      {/* <select required>
                        <option value="">Target PTE Score</option>
                        <option value="50+">50+</option>
                        <option value="58+">58+</option>
                        <option value="65+">65+</option>
                        <option value="79+">79+</option>
                      </select> */}
                      <select
                        name="timeSlot"
                        value={StudentForm.timeSlot}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Preferred Batch</option>
                        <option value="morning">Morning</option>
                        <option value="evening">Evening</option>
                        <option value="weekend">Weekend</option>
                      </select>

                      {error ? (
                        <p style={{ color: "red" }}> {error}</p>
                      ) : success ? (
                        <p style={{ color: "green" }}>{success}</p>
                      ) : (
                        ""
                      )}
                      <button type="submit" class="btn-form">
                        Book Free Demo
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- Why Choose Section --> */}
        <section class="why-choose">
          <div class="container">
            <div class="section-header">
              <h2>Why Choose Testifyi Delhi</h2>
              <p>
                Experience excellence in PTE preparation with our proven
                methodology
              </p>
            </div>

            <div class="features-grid">
              <div class="feature">
                <div class="feature-icon">🎯</div>
                <h3>Proven 79+ Score Strategy</h3>
                <p>
                  Our tested methodology helps students achieve their target PTE
                  scores consistently
                </p>
              </div>
              <div class="feature">
                <div class="feature-icon">👨‍🏫</div>
                <h3>Delhi-based Trainers</h3>
                <p>
                  Expert local trainers with deep understanding of student needs
                  and challenges
                </p>
              </div>
              <div class="feature">
                <div class="feature-icon">📝</div>
                <h3>Mock Tests with Real-time Evaluation</h3>
                <p>
                  Practice with authentic PTE mock tests and get instant
                  detailed feedback
                </p>
              </div>
              <div class="feature">
                <div class="feature-icon">🤖</div>
                <h3>AI Feedback for Speaking & Writing</h3>
                <p>
                  Advanced AI technology provides precise feedback on your
                  performance
                </p>
              </div>
              <div class="feature">
                <div class="feature-icon">🏆</div>
                <h3>Community-based Learning</h3>
                <p>
                  Join a supportive community with peer learning and achievement
                  rewards
                </p>
              </div>
              <div class="feature">
                <div class="feature-icon">📊</div>
                <h3>Performance Tracking Dashboard</h3>
                <p>
                  Monitor your progress with detailed analytics and personalized
                  insights
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* 
    <!-- Student Testimonials --> */}
        <section class="testimonials" id="testimonials">
          <div class="container">
            <div class="section-header">
              <h2>Success Stories</h2>
              <p>
                Hear from our successful students who achieved their dream PTE
                scores
              </p>
            </div>

            <div class="testimonials-grid">
              <Slider {...why_choose}>
                <div>
                  <div class="testimonial">
                    <div class="testimonial-content">
                      <div class="stars">⭐⭐⭐⭐⭐</div>
                      <p>
                        "Testifyi helped me achieve 85 in PTE Academic. The AI
                        feedback system was incredibly helpful for improving my
                        speaking and writing skills."
                      </p>
                      <div class="testimonial-author">
                        <img
                          src="https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=150"
                          alt="Student"
                        />
                        <div>
                          <h4>Priya Sharma</h4>
                          <span>Score: 85 | Australia PR</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="testimonial">
                    <div class="testimonial-content">
                      <div class="stars">⭐⭐⭐⭐⭐</div>
                      <p>
                        "The mock tests were exactly like the real exam. I
                        scored 79 on my first attempt thanks to the
                        comprehensive preparation at Testifyi."
                      </p>
                      <div class="testimonial-author">
                        <img
                          src="https://images.pexels.com/photos/2182970/pexels-photo-2182970.jpeg?auto=compress&cs=tinysrgb&w=150"
                          alt="Student"
                        />
                        <div>
                          <h4>Rahul Kumar</h4>
                          <span>Score: 79 | Canada Immigration</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="testimonial">
                    <div class="testimonial-content">
                      <div class="stars">⭐⭐⭐⭐⭐</div>
                      <p>
                        "Excellent coaching with personalized attention. The
                        trainers helped me overcome my speaking anxiety and
                        achieve my target score of 65."
                      </p>
                      <div class="testimonial-author">
                        <img
                          src="https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=150"
                          alt="Student"
                        />
                        <div>
                          <h4>Anjali Gupta</h4>
                          <span>Score: 65 | UK Study Visa</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="testimonial">
                    <div class="testimonial-content">
                      <div class="stars">⭐⭐⭐⭐⭐</div>
                      <p>
                        "Testifyi helped me achieve 85 in PTE Academic. The AI
                        feedback system was incredibly helpful for improving my
                        speaking and writing skills."
                      </p>
                      <div class="testimonial-author">
                        <img
                          src="https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=150"
                          alt="Student"
                        />
                        <div>
                          <h4>Priya Sharma</h4>
                          <span>Score: 85 | Australia PR</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="testimonial">
                    <div class="testimonial-content">
                      <div class="stars">⭐⭐⭐⭐⭐</div>
                      <p>
                        "The mock tests were exactly like the real exam. I
                        scored 79 on my first attempt thanks to the
                        comprehensive preparation at Testifyi."
                      </p>
                      <div class="testimonial-author">
                        <img
                          src="https://images.pexels.com/photos/2182970/pexels-photo-2182970.jpeg?auto=compress&cs=tinysrgb&w=150"
                          alt="Student"
                        />
                        <div>
                          <h4>Rahul Kumar</h4>
                          <span>Score: 79 | Canada Immigration</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="testimonial">
                    <div class="testimonial-content">
                      <div class="stars">⭐⭐⭐⭐⭐</div>
                      <p>
                        "Excellent coaching with personalized attention. The
                        trainers helped me overcome my speaking anxiety and
                        achieve my target score of 65."
                      </p>
                      <div class="testimonial-author">
                        <img
                          src="https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=150"
                          alt="Student"
                        />
                        <div>
                          <h4>Anjali Gupta</h4>
                          <span>Score: 65 | UK Study Visa</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </section>

        {/* <!-- Course Overview --> */}
        <section class="course-overview" id="courses">
          <div class="container">
            <div class="section-header">
              <h2>Course Overview</h2>
              <p>
                Comprehensive PTE preparation programs designed for your success
              </p>
            </div>

            <div class="course-grid">
              <div class="course-card">
                <div class="course-header">
                  <h3>PTE Academic Complete</h3>
                  <div class="price">₹15,999</div>
                </div>
                <ul class="course-features">
                  <li>✓ All 4 modules coverage</li>
                  <li>✓ 40+ mock tests</li>
                  <li>✓ Daily doubt sessions</li>
                  <li>✓ Score tracking dashboard</li>
                  <li>✓ AI-powered feedback</li>
                  <li>✓ Study materials included</li>
                  <li>✓ 3 months validity</li>
                </ul>
                <button class="btn-course">Enroll Now</button>
              </div>

              <div class="course-card featured">
                <div class="popular-badge">Most Popular</div>
                <div class="course-header">
                  <h3>PTE Academic Premium</h3>
                  <div class="price">₹24,999</div>
                </div>
                <ul class="course-features">
                  <li>✓ Everything in Complete</li>
                  <li>✓ One-on-one sessions</li>
                  <li>✓ Priority doubt resolution</li>
                  <li>✓ Advanced practice materials</li>
                  <li>✓ Score guarantee</li>
                  <li>✓ Interview preparation</li>
                  <li>✓ 6 months validity</li>
                </ul>
                <button class="btn-course">Enroll Now</button>
              </div>

              <div class="course-card">
                <div class="course-header">
                  <h3>PTE Academic Crash Course</h3>
                  <div class="price">₹9,999</div>
                </div>
                <ul class="course-features">
                  <li>✓ 2-week intensive program</li>
                  <li>✓ 20 mock tests</li>
                  <li>✓ Daily live sessions</li>
                  <li>✓ Quick score improvement</li>
                  <li>✓ Expert tips & tricks</li>
                  <li>✓ Study materials</li>
                  <li>✓ 1 month validity</li>
                </ul>
                <button class="btn-course">Enroll Now</button>
              </div>
            </div>
          </div>
        </section>
        <div className="Delhi_Ielts">
          {/* <!-- Batch Schedule Section --> */}
          <section class="batch-schedule">
            <div class="container">
              <div class="section-header">
                <h2>Batch Schedule</h2>
                <p>
                  Choose from flexible timing options that fit your schedule.
                  Small batch sizes ensure personalized attention.
                </p>
              </div>

              <div class="batches-grid">
                <Slider
                  style={{ width: "100%", background: "white" }}
                  {...why_choose}
                >
                  <div>
                    <div class="batch-card morning">
                      <div class="batch-icon">
                        <FaSun color="#FACC15" />
                      </div>
                      <h3>Morning Batch</h3>
                      <div class="batch-time">
                        <FaClock
                          color="#FB7185"
                          style={{ marginBottom: "-2px" }}
                        />{" "}
                        9:00 AM - 12:00 PM
                      </div>
                      <p class="batch-days">Monday to Friday</p>
                      <div class="batch-details">
                        <div class="detail-row">
                          <span>Batch Size:</span>
                          <span>15 students max</span>
                        </div>
                        <div class="detail-row">
                          <span>Duration:</span>
                          <span>6-8 weeks</span>
                        </div>
                        <div class="detail-row">
                          <span>Availability:</span>
                          <span class="available">8 seats available</span>
                        </div>
                      </div>
                      <button class="btn btn-primary">Reserve Your Seat</button>
                    </div>
                  </div>

                  <div>
                    <div class="batch-card evening">
                      <div class="batch-icon">
                        <MdWbTwilight
                          color="#FB923C"
                          style={{ marginBottom: "-2px" }}
                        />
                      </div>
                      <h3>Evening Batch</h3>
                      <div class="batch-time">
                        <FaClock
                          color="#FB7185"
                          style={{ marginBottom: "-2px" }}
                        />{" "}
                        6:00 PM - 9:00 PM
                      </div>
                      <p class="batch-days">Monday to Friday</p>
                      <div class="batch-details">
                        <div class="detail-row">
                          <span>Batch Size:</span>
                          <span>15 students max</span>
                        </div>
                        <div class="detail-row">
                          <span>Duration:</span>
                          <span>6-8 weeks</span>
                        </div>
                        <div class="detail-row">
                          <span>Availability:</span>
                          <span class="available">5 seats available</span>
                        </div>
                      </div>
                      <button class="btn btn-primary">Reserve Your Seat</button>
                    </div>
                  </div>

                  <div>
                    <div class="batch-card weekend">
                      <div class="batch-icon">
                        <FaRegCalendarAlt color="#0EA5E9" />
                      </div>
                      <h3>Weekend Batch</h3>
                      <div class="batch-time">
                        <FaClock
                          color="#FB7185"
                          style={{ marginBottom: "-2px" }}
                        />{" "}
                        10:00 AM - 4:00 PM
                      </div>
                      <p class="batch-days">Saturday & Sunday</p>
                      <div class="batch-details">
                        <div class="detail-row">
                          <span>Batch Size:</span>
                          <span>15 students max</span>
                        </div>
                        <div class="detail-row">
                          <span>Duration:</span>
                          <span>6-8 weeks</span>
                        </div>
                        <div class="detail-row">
                          <span>Availability:</span>
                          <span class="available">12 seats available</span>
                        </div>
                      </div>
                      <button class="btn btn-primary">Reserve Your Seat</button>
                    </div>
                  </div>
                </Slider>
              </div>
              <div class=" New_Table_class">
                <div class="section-header" style={{ marginBottom: "0" }}>
                  <h2>Upcoming Batch Dates</h2>
                </div>

                <div className="container">
                  <div class="">
                    <table class="batch-table">
                      <thead>
                        <tr className="">
                          <th>Batch Type</th>
                          <th>Start Date</th>
                          <th>Duration</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td data-label="Batch Type">Morning Batch</td>
                          <td data-label="Start Date">January 15, 2025</td>
                          <td data-label="Duration">6 weeks</td>
                          <td data-label="Status">
                            <span class="status-badge status-filling">
                              Filling Fast
                            </span>
                          </td>
                          <td data-label="Action">
                            <button class="enroll-btn">Enroll Now</button>
                          </td>
                        </tr>
                        <tr>
                          <td data-label="Batch Type">Evening Batch</td>
                          <td data-label="Start Date">January 20, 2025</td>
                          <td data-label="Duration">6 weeks</td>
                          <td data-label="Status">
                            <span class="status-badge status-available">
                              Available
                            </span>
                          </td>
                          <td data-label="Action">
                            <button class="enroll-btn">Enroll Now</button>
                          </td>
                        </tr>
                        <tr>
                          <td data-label="Batch Type">Weekend Batch</td>
                          <td data-label="Start Date">January 18, 2025</td>
                          <td data-label="Duration">8 weeks</td>
                          <td data-label="Status">
                            <span class="status-badge status-new">
                              New Batch
                            </span>
                          </td>
                          <td data-label="Action">
                            <button class="enroll-btn">Enroll Now</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="early-bird-offer">
                  <h4>
                    <span>
                      <MdRocketLaunch color="#F97316" />
                    </span>{" "}
                    Early Bird Offer
                  </h4>
                  <p>
                    Register 1 week before batch start and get 20% discount +
                    Free study materials worth ₹5,000
                  </p>
                  <button class="btn btn-white">Claim Early Bird Offer</button>
                </div>
              </div>
            </div>
          </section>

          {/* <!-- Location Section --> */}
          <section class="location">
            <div class="container">
              <div class="section-header">
                <h2>Visit Our Delhi Center</h2>
                <p>
                  Conveniently located in the heart of Delhi with easy access to
                  public transport and parking
                </p>
              </div>

              <div class="location-content">
                {/* <div class="contact-info">
                <div class="contact-card">
                  <h3>Get in Touch</h3>
                  <div class="contact-item">
                    <div class="contact-icon">📍</div>
                    <div>
                      <h4>Address</h4>
                      <p>
                        SCO 45-46, Second Floor
                        <br />
                        Sector 17-C, Delhi
                        <br />
                        Punjab 160017, India
                      </p>
                    </div>
                  </div>
                  <div class="contact-item">
                    <div class="contact-icon">📞</div>
                    <div>
                      <h4>Phone</h4>
                      <p>
                        +91 98765 43210
                        <br />
                        +91 98765 43211
                      </p>
                    </div>
                  </div>
                  <div class="contact-item">
                    <div class="contact-icon">✉️</div>
                    <div>
                      <h4>Email</h4>
                      <p>
                        info@testifyi.com
                        <br />
                        Delhi@testifyi.com
                      </p>
                    </div>
                  </div>
                  <div class="contact-item">
                    <div class="contact-icon">🕒</div>
                    <div>
                      <h4>Operating Hours</h4>
                      <p>
                        Monday - Friday: 9:00 AM - 9:00 PM
                        <br />
                        Saturday - Sunday: 10:00 AM - 6:00 PM
                      </p>
                    </div>
                  </div>

                  <div class="directions-info">
                    <h4>🧭 How to Reach</h4>
                    <ul>
                      <li>• 2 minutes walk from Sector 17 Plaza</li>
                      <li>• Bus Stop: Sector 17 (50 meters away)</li>
                      <li>• Metro: Take bus from Delhi Railway Station</li>
                      <li>• Parking: Available at Sector 17 Plaza</li>
                    </ul>
                  </div>
                </div>

                <div class="counseling-cta">
                  <h3>🎯 Book a Free Counseling Session</h3>
                  <p>
                    Visit our center for personalized IELTS guidance and free
                    practice test
                  </p>
                  <button class="btn btn-white">Schedule Visit</button>
                </div>
              </div> */}

                <div class="map-section">
                  <h3>Find Us on Map</h3>
                  <div class="map-container">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.2431682741694!2d77.2504521!3d28.5486732!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce35adb1e9e1f%3A0xf8cd70d1f67432d3!2s38%2C%20Ansal%20Tower%2C%20115%2C%20Nehru%20Place%2C%20New%20Delhi%2C%20Delhi%20110019!5e0!3m2!1sen!2sin!4v1691654356789!5m2!1sen!2sin"
                      width="100%"
                      height="300"
                      style={{ border: "0" }}
                      allowfullscreen=""
                      loading="lazy"
                      referrerpolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                  <div class="map-buttons">
                    <a
                      class="btn btn-primary"
                      href="https://www.google.com/maps/dir/?api=1&destination=38+Ansal+Tower+115+Nehru+Place+New+Delhi+Delhi+110019"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>
                        <FaCompass />{" "}
                      </span>{" "}
                      Get Directions
                    </a>
                    <a
                      class="btn btn-success"
                      href="tel:9289192873"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>
                        {" "}
                        <FaPhone />{" "}
                      </span>{" "}
                      Call Now
                    </a>
                  </div>
                  <div class="pickup-service">
                    <h4>🚗 Free Parking Service</h4>
                    <p>
                      We provide free Parking service for students from
                      Panchkula, Mohali, and nearby areas for the first class!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* <!-- FAQs --> */}
        <section class="faqs">
          <div class="container">
            <div class="section-header">
              <h2>Frequently Asked Questions</h2>
              <p>Get answers to common queries about our PTE coaching</p>
            </div>

            <div class="faq-list">
              {Faq?.map((ev, i) => (
                <div class="faq-item">
                  <div class="faq-question" onClick={() => setFaqActive(i)}>
                    <h3>{ev?.title}</h3>
                    <span class="faq-toggle">+</span>
                  </div>
                  <div
                    class={i == FaqActive ? "faq-answer active" : "faq-answer"}
                  >
                    <p>{ev?.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
}
